import React, {PureComponent} from "react"
import styled, {css} from "styled-components"
import {Row} from "react-bootstrap"

import {CompanyValue} from "@irati/companyvalues/types"
import {FormattedMessage} from "@irati/utils/lang"
import {H4, Body} from "@irati/ui/src/Typography"
import Button from "@irati/ui/src/Button"
import HR from "@irati/ui/src/Layout/Hr"
import theme from "@irati/ui/src/global/theme"
import id from "@irati/utils/id"
import Flex from "@irati/ui/src/Flex"

const CompanyValueInfo = styled.div``

const StyledBody = styled(Body)`
  overflow: hidden;
  text-overflow: ellipsis;
`

const textBreak = css`
  word-break: break-all;
  word-break: break-word;
`

const StyledH4 = styled(H4)`
  display: inline-block;
  padding-right: 5px;
  ${textBreak}
`

const StyledTag = styled(H4)`
  color: ${theme.colors.brand.default};
  display: inline-block;
  ${textBreak}
`

const TextWrapper = styled.div`
  margin-bottom: 5px;
`

const MarginButton = styled(Button)`
  margin-right: 20px;
`

interface Props {
  archiveCompanyValue(): void
  editCompanyValue(): void
  companyValue: CompanyValue
  id: string
}

class CompanyValueRow extends PureComponent<Props> {
  render() {
    const {archiveCompanyValue, editCompanyValue, companyValue} = this.props

    return (
      <Row>
        <Flex alignItems="center" justifyContent="space-between" marginBottom={2}>
          <CompanyValueInfo>
            <TextWrapper>
              <StyledH4>{companyValue.name}</StyledH4>
              <StyledTag>(#{companyValue.tag})</StyledTag>
            </TextWrapper>
            <TextWrapper>
              <StyledBody small marginBottom={1}>
                {companyValue.desc}
              </StyledBody>
            </TextWrapper>
          </CompanyValueInfo>
          <Flex alignItems="center" justifyContent="center">
            <MarginButton small id={id("editButton", this.props)} onClick={editCompanyValue}>
              <FormattedMessage id="admin.companyValues.list.edit" />
            </MarginButton>
            <Button small id={id("archiveButton", this.props)} onClick={archiveCompanyValue}>
              <FormattedMessage id="admin.companyValues.list.archive" />
            </Button>
          </Flex>
        </Flex>
        <HR />
      </Row>
    )
  }
}

export default CompanyValueRow
